import { z } from 'zod/v4';

type SortOption = {
  id: string;
  desc: boolean;
};

export function createPaginationSchema(defaultSort: SortOption) {
  return z.object({
    limit: z.coerce.number().optional().default(25),
    offset: z.coerce.number().optional().default(0),
    page: z.coerce.number().optional(),
    group: z.enum(['category']).optional(),
    sort: z
      .string()
      .optional()
      .transform((val) => {
        if (!val) {
          return [defaultSort];
        }

        try {
          const parsed = JSON.parse(val);
          const sortSchema = z.array(
            z.object({
              id: z.string(),
              desc: z.boolean(),
            }),
          );

          const result = sortSchema.safeParse(parsed);

          if (!result.success) {
            return [defaultSort];
          }

          return result.data;
        } catch {
          return [defaultSort];
        }
      })
      .default([]),
  });
}

export function createQuerySchemaWithPagination<T extends z.ZodRawShape>(
  baseSchema: z.ZodObject<T>,
  defaultSort: SortOption,
) {
  return baseSchema.merge(createPaginationSchema(defaultSort));
}